import { lazy } from "react";

const FullLayout = lazy(() => import("../layouts/FullLayout.js"));
const PortalVer = lazy(() => import("../portal/pages/portal-ver/PortalVer"));
const QuienesSomos = lazy(() => import("../portal/pages/quienes-somos/QuienesSomos"));
const OlvidoPassword = lazy(() => import("../portal/pages/olvido-contraseña/OlvidoPassword"));
const Register = lazy(() => import("../portal/pages/register/Register"));
const ChangeClientPassword = lazy(() => import("../portal/components/ChangeCLientPassword/ChangeCLientPassword"));
const EditCliente = lazy(() => import("../portal/pages/edit-cliente/EditCliente"));


var indexRoutes = [
  { path: "/home", name: "Portal", component: PortalVer },
  { path: "/quienes-somos", name: "Portal", component: QuienesSomos},
  {path: "/comprar-por-proyecto", name: "Portal", component: QuienesSomos},
  { path: "/register", name: "Portal", component: Register},
  { path: "/olvido-contraseña", name: "Portal", component: OlvidoPassword},
  { path: "/change-password/:id", name: "Portal", component: ChangeClientPassword},
  { path: "/edit-cliente/:id", name: "Portal", component: EditCliente},
  { path: "/", name: "Dashboard", component: FullLayout },
];

export default indexRoutes;
